import TagIcon from './TagIcon';
import TagText from './TagText';

export { TagIcon, TagText };
